import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import FleetWebApi from "../Api/FleetWebApi";
import alertLabsApi from "../Api/AlertLabsApi";
import { useEffect } from "react";
import { useState } from "react";
import { useAuthDataContext } from "../AuthDataProvider";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Moment from "react-moment";
import TableHead from "@mui/material/TableHead";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

function NotesDetails(props) {
  const [alert, setAlert] = useState(false);
  const [submitError, setsubmitError] = useState(null);
  const [take] = useState(10);
  const [skip, setSkip] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [notesDetails, setNotesDetails] = useState(null);
  const [noteInput, setNoteInput] = useState("");
  const { user } = useAuthDataContext();
  const [refreshNotes, setRefreshNotes] = useState(false);
  const onTextChange = (e) => setNoteInput(e.target.value);
  const handleSubmit = () => {
    submit();
  };
  const nextPage = () => {
    setSkip(skip + take);
  };

  const previousPage = () => {
    setSkip(skip - take);
  };

  const forceRefresh = () => {
    setRefreshNotes(!refreshNotes);
  };
  async function submit() {
    if (noteInput) {
      await FleetWebApi.addNote(
        props.Id,
        noteInput,
        props.model_type,
        user.user_details.name
      ).then(
        (result) => {
          setNoteInput("");
          setAlert(true);
        },
        (error) => {
          setsubmitError(error.message);
        }
      );
    }
  }
  useEffect(() => {
    let isMounted = true;
    
    const fetchNotes = async () => {
      try {
        // For Device type notes, check if there's a virtual sensor ID
        if (props.model_type === "Device") {
          const virtualIDs = await alertLabsApi.getVirtualSensorID(props.Id, user.token);
          
          // Check if virtual ID exists and is different from particle core ID
          const hasVirtualId = virtualIDs?.[0] && virtualIDs[0] !== props.Id;
          
          if (hasVirtualId) {
            console.log(`Fetching notes for both particle core ID (${props.Id}) and virtual sensor ID (${virtualIDs[0]})`);
            
            // Fetch notes for both particle core ID and virtual sensor ID (in case there are old records still using the virtual id)
            const [coreIdNotes, virtualIdNotes] = await Promise.all([
              FleetWebApi.getAllNotes(props.Id, props.model_type, skip, take, false),
              FleetWebApi.getAllNotes(virtualIDs[0], props.model_type, skip, take, false)
            ]);
            
            // Combine and get rid of duplicate notes based on timestamp and note content
            const allNotes = [...coreIdNotes, ...virtualIdNotes];
            const uniqueNotes = allNotes.filter((note, index, self) =>
              index === self.findIndex((n) => 
                n.timestamp === note.timestamp && n.note === note.note
              )
            );
            
            uniqueNotes.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
            
            if (isMounted) {
              setNotesDetails(uniqueNotes);
              setIsLoaded(true);
              setError(null);
            }
            return; 
          }
        }
        
        // Fetch notes normally if not virtual id
        const result = await FleetWebApi.getAllNotes(props.Id, props.model_type, skip, take, false);
        if (isMounted) {
          setNotesDetails(result);
          setIsLoaded(true);
          setError(result.error);
        }
      } catch (error) {
        if (isMounted) {
          console.log(error);
          setIsLoaded(true);
          setError(error.message);
        }
      }
    };
    
    fetchNotes();
    
    return () => {
      isMounted = false;
    };
  }, [props.Id, props.model_type, refreshNotes, skip, take, user.token]);
  let createNoteComponent = (
    <div>
      <h4>Create Note</h4>
      <TextField
        id="create note"
        label="Create Note"
        multiline
        minRows={5}
        variant="filled"
        fullWidth
        color="secondary"
        onChange={onTextChange}
        value={noteInput}
      />
      <Button
        variant="contained"
        type="submit"
        color="secondary"
        label="Add Note"
        style={{ marginLeft: 373, marginRight: 0, marginTop: 10 }}
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </div>
  );
  let addSuccessfulContainer = (
    <div>
      {alert ? (
        <Alert
          severity="success"
          onClose={() => {
            setAlert(false);
            forceRefresh();
          }}
        >
          <AlertTitle>Note added successfully!</AlertTitle>
          Please close this alert to refresh the page.
        </Alert>
      ) : null}
    </div>
  );
  let addErrorContainer = (
    <div>
      {submitError ? (
        <Alert
          severity="error"
          onClose={() => {
            setsubmitError(null);
          }}
        >
          <AlertTitle>Error!</AlertTitle>
          {submitError}
        </Alert>
      ) : null}
    </div>
  );
  let notesDetailsContainer;
  if (error) {
    notesDetailsContainer = (
      <Container maxWidth="lg">
        {addErrorContainer}
        {addSuccessfulContainer}
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={5}>
            <h4>Existing Notes</h4>
            Error: {error}
          </Grid>
          <Grid item xs={12} md={6} lg={5}>
            {createNoteComponent}
          </Grid>
        </Grid>
      </Container>
    );
    return notesDetailsContainer;
  } else if (!isLoaded) {
    return (
      <div>
        <CircularProgress color="secondary" />
      </div>
    );
  } else {
    notesDetailsContainer = (
      <Container maxWidth="lg">
        {addErrorContainer}
        {addSuccessfulContainer}

        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={5}>
            {createNoteComponent}
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper>
              <Table classes={{ root: "reactivetable" }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>User</TableCell>
                    <TableCell>Note</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notesDetails
                    ? notesDetails.map((row, key) => (
                        <TableRow key={key}>
                          <TableCell data-th="Date">
                            {row.timestamp ? (
                              <Moment format="YYYY-MM-DD HH:mm:ss Z">
                                {row.timestamp}
                              </Moment>
                            ) : (
                              <div>-</div>
                            )}
                          </TableCell>
                          <TableCell data-th="User">{row.user_name}</TableCell>
                          <TableCell data-th="Note">{row.note}</TableCell>
                        </TableRow>
                      ))
                    : null}
                </TableBody>
              </Table>
              {notesDetails ? (
                <div>
                  {skip !== 0 && (
                    <IconButton onClick={previousPage}>
                      <ArrowBackIcon />
                    </IconButton>
                  )}
                  {!error &&
                    notesDetails.length !== 0 &&
                    take === notesDetails.length && (
                      <IconButton onClick={nextPage}>
                        <ArrowForwardIcon />
                      </IconButton>
                    )}
                  {!error && (
                    <IconButton onClick={forceRefresh}>
                      <RefreshIcon />
                    </IconButton>
                  )}
                </div>
              ) : null}
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
    return notesDetailsContainer;
  }
}

export default NotesDetails;
